import Layout from 'components/BionicUI/layout/Layout';
import BPSpinner from 'components/BionicUI/loading/BPSpinner';
// import { OnboardingPhases } from 'core/models/users/user.model';
import { DateTime } from 'luxon';
import { FC } from 'react';
import ApplicationProgressBox, {
  ProgressStage,
} from './ApplicationProgressBox';
// import FAQs from './FAQs';
import { useApplication } from './applicationData';
import './ApplicationInReview.css';
// import CurlyBg from './curly-bg.jpg';
// import axios from 'axios';
// import BPButton from 'components/BionicUI/button/BPButton';
// import BPIcon from 'components/BionicUI/icons/BPIcon';
// import BPVideoOverlay from 'components/BionicUI/video/BPVideoOverlay';

const ApplicationInReview: FC = () => {
  const { progressData, lastUpdated, userRoles } = useApplication();

  return (
    <Layout showSearchBar={false} showProfile={false} linkLogo={false}>
      <BgImage />
      <div className="grid w-full gap-[80px] pade-side-padding z-[1] relative mb-[48px]">
        <PageHeader progressData={progressData} lastUpdated={lastUpdated} />
        <ApplicationProgressBox
          progress={progressData}
          lastUpdated={lastUpdated}
          userRoles={userRoles}
        />
        {/* {onboardingPhase === OnboardingPhases.USER_APPLICATION_SUBMITTED && (
          <BoostYourChances vimeoUrl="https://vimeo.com/1034218832" />
        )} */}
        {/* <FAQs /> */}
      </div>
    </Layout>
  );
};

// const BoostYourChances: FC<{ vimeoUrl: string }> = ({ vimeoUrl }) => {
//   const [videoPosterUrl, setVideoPosterUrl] = useState<string>('');
//   const [showVideo, setShowVideo] = useState<boolean>(false);

//   useEffect(() => {
//     if (!vimeoUrl) return;
//     axios
//       .get(`https://vimeo.com/api/oembed.json?url=${vimeoUrl}`)
//       .then((response) =>
//         setVideoPosterUrl(
//           response.data.thumbnail_url.replace(/-d_\d+x\d+/, '-d_1920x1080')
//         )
//       );
//   }, [vimeoUrl]);

//   return (
//     <div className="grid relative w-full grid-cols-[1fr_auto] gap-6 page-side-padding text-[18px]">
//       <div className="grid relative grid-rows-[auto_1fr]">
//         <div className="grid relative gap-5">
//           <h1>Boost your chances</h1>
//           <div>Not everyone will get in.</div>
//           <div>
//             There are a few things you can do to improve your chances of
//             success. Watch the video to find out more.
//           </div>
//           <div className="grid relative grid-cols-[250px_1fr] mt-5">
//             <BPButton state="glass" onClick={() => setShowVideo(true)}>
//               Watch Video <BPIcon icon="playButton" />
//             </BPButton>
//             <div />
//           </div>
//         </div>
//         <div />
//       </div>
//       {videoPosterUrl && (
//         <img
//           src={videoPosterUrl}
//           alt="Boost your chances"
//           className="block object-cover w-[45vw] aspect-video animate-fade-in rounded-[8px]"
//         />
//       )}
//       {showVideo && (
//         <BPVideoOverlay
//           vimeoUrl={vimeoUrl ?? ''}
//           handleClose={() => setShowVideo(false)}
//         />
//       )}
//     </div>
//   );
// };

const BgImage = () => (
  <>
    <img
      src={'/images/ai-girl.png'}
      className="block fixed top-[104px] sm:top-0 left-1/2 transform -translate-x-1/2 sm:-translate-x-0 sm:left-auto sm:right-0 w-[85vw] sm:w-[60vw] h-auto z-[1] bottom-fade-mask"
    />
    <img
      src={'/images/bg-boxes.png'}
      className="block fixed top-[104px] sm:top-0 left-1/2 transform -translate-x-1/2 sm:-translate-x-0 sm:left-auto sm:right-0 w-[85vw] sm:w-[60vw] h-auto z-0"
    />
    <img
      src={'/images/left-bottom-shadow.png'}
      className="block fixed bottom-0 left-0 w-[40vw] h-auto z-0"
    />
    <img
      src={'/images/top-shadow.png'}
      className="block fixed top-0 right-0 w-[80vw] h-auto z-0"
    />
    <img
      src={'/images/girl-back-shadow.png'}
      className="hidden sm:block fixed top-1/2 left-1/2 w-[60vw] h-auto z-0 girl-shadow-animated"
    />
  </>
);

const PageHeader: FC<{
  lastUpdated: DateTime;
  progressData: ProgressStage[] | undefined;
}> = ({ lastUpdated, progressData }) => (
  <div className="grid relative gap-3 pt-[60vw] sm:pt-12 px-6 sm:page-side-padding">
    <div
      key={lastUpdated.toISO()}
      className="grid grid-cols-[auto_1fr] gap-3 items-center text-[12px] text-bionic-muted tracking-wide animate-fade-in"
    >
      <div>
        <BPSpinner width={20} />
      </div>
      <div>Last updated {lastUpdated.toFormat('h:mm:ssa').toLowerCase()}</div>
    </div>
    <h1 className="font-kernalBold font-semibold leading-none">
      {progressData &&
      progressData.length === 3 &&
      progressData[1].status === 'pending'
        ? 'Ready To Onboard'
        : 'Application in Review'}
    </h1>
    {progressData &&
    progressData.length === 3 &&
    progressData[1].status === 'pending' ? (
      <div className="text-bionic-muted">Thank you.</div>
    ) : (
      <>
        <div className="text-bionic-muted">
          Our AI agents are running initial scoring of your project.
        </div>
        <div className="text-bionic-muted max-w-[565px]">
          We aim to get back to you as soon as possible. You will be notified on
          the status of your application via email. Log in at any point via
          bionicdao.com to check the status of your application here.
        </div>
      </>
    )}
    {progressData &&
    progressData.length === 3 &&
    progressData[1].status === 'pending' ? (
      <div className="text-bionic-muted max-w-[565px]">
        Your account creation is complete, and you can start onboarding your
        project below, getting one step closer to fundraising.
      </div>
    ) : (
      <div className="text-bionic-muted max-w-[565px]">
        Join our community on{' '}
        <a href="https://discord.com/invite/hbEKzMu22F">Discord</a> and{' '}
        <a href="https://t.me/officialbionicdao">Telegram</a> to stay updated.
      </div>
    )}
  </div>
);

export default ApplicationInReview;
